import React from 'react'

import { tagLinkBlocksShape } from 'Pods/Shared/TagLinkRow/tagLinkBlocksShape'
import TagLinkRow from 'Pods/Shared/TagLinkRow/TagLinkRow'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

function TagLinkVariants({ blocks = null }) {
  if (!blocks) {
    return null
  }

  const styleVariants = blocks.styleVariants || EMPTY_ARRAY
  const softwareVariants = blocks.softwareVariants || EMPTY_ARRAY

  if (styleVariants.length === 0 && softwareVariants.length === 0) {
    return null
  }

  return (
    <div className="tag-link-variants">
      <TagLinkRow label={blocks.styleHeading} links={styleVariants} />
      <TagLinkRow label={blocks.softwareHeading} links={softwareVariants} />
    </div>
  )
}

TagLinkVariants.propTypes = {
  blocks: tagLinkBlocksShape,
}

export default TagLinkVariants
